module.exports = __webpack_public_path__ + "img/linklogo3.e2d94de8.png";